import ActionTypes from './actionTypes';

// close side menu
export const closeSideMenu = () => ({ type: ActionTypes.CLOSE_SIDE_MENU });

// toggle side menu
export const toggleSideMenu = () => ({ type: ActionTypes.TOGGLE_SIDE_MENU });
